(function (module) {
    'use strict';

    function fileTileCtrl() {
        this.$onInit = () => {
            this.hideSaveButtonFlag = true;
            this.hideEditButtonFlag = false;
            this.editTitle = false;
            this.checked = false;
            this.fileTypeHeader = '';
            if (this.fileType && this.fileType.startsWith('video')) {
                this.fileTypeHeader = 'video';
                this.overlayIcon = 'fa fa-play';
            }
            if (this.fileType && this.fileType.startsWith('image')) {
                this.fileTypeHeader = 'image';
                this.overlayIcon = 'fa fa-arrows-alt';
            }
            if (this.frameRate) {
                this.frameRate = this.frameRate.split('/');
                let frameRateNumArr = [];
                this.frameRate.forEach((item) => {
                    const itemNum = parseInt(item, 10);
                    frameRateNumArr.push(itemNum);
                });
                this.frameRate = Math.round(frameRateNumArr[0] / frameRateNumArr[1]) || 'N/A';

            }
        };
    }

    module
        .component('fileTile', {
            templateUrl: '/js/components/file-tile/file-tile.html',
            controller: fileTileCtrl,
            bindings: {

                // title
                titleShow: '<',
                titleName: '<',
                editTitle: '<',
                fileSize: '<',
                fileType: '<',
                fileId: '<',
                fileTypeHeader: '<',
                fileCreatedAt: '<',
                resolution: '<',
                codecName: '<',
                codecTagString: '<',
                frameRate: '<',
                checked: '<',
                isChecked: '&',
                duration: '<',
                displayTime: '<',

                //preview
                overlayText: '@',
                overlayClick: '&',

                // save
                saveClick: '&',
                hideSaveButtonFlag: '<',

                // edit
                editClick: '&',
                hideEditButtonFlag: '<',

                // displayTime
                setDisplayTime: '&',
                showDisplayTime: '<',

                // delete
                deleteClick: '&',

                backgroundImage: '<',
                form: '='

            }
        });
})(angular.module('rocket.components'));
